export default {
    setEditsList(state, list) {
        state.editsList = list;
    }
}
